const getConfigPropertyValue = ({
  siteConfig,
  siteName,
  key,
  defaultValue,
  log = console
}) => {
  const { org, site } = getSiteMetaDataFromSiteName(siteName);
  const keyName = key.toLowerCase();
  let propertyValue = getPropertyValueFromConfig({
    key: keyName,
    rootConfig: siteConfig?.[org]?.sites?.[site],
    log
  });

  if (propertyValue === undefined) {
    propertyValue = getPropertyValueFromConfig({
      key: keyName,
      rootConfig: siteConfig?.[org] || {},
      defaultValue,
      log
    });
  }
  return propertyValue;
};

const getSiteMetaDataFromSiteName = (siteName) => {
  let metadata = {};
  if (siteName) {
    /* eslint-disable camelcase */
    const siteNameArray = siteName.toLowerCase().split("_");
    // siteNameArray[0] give Bu value. siteNameArray[1] gives product value
    const business_unit = siteNameArray[0] ? siteNameArray[0] : "";
    const product = siteNameArray[1] ? siteNameArray[1] : "";
    const org = `${business_unit}_${product}`;
    const site = siteNameArray[2] ? siteNameArray.splice(2).join("_") : "";

    metadata = {
      business_unit,
      product,
      org,
      site
    };
  }
  /* eslint-enable camelcase */
  return metadata;
};

const getPropertyValueFromConfig = ({
  key = "",
  rootConfig,
  defaultValue = undefined,
  log
}) => {
  // Key format could be 'ersonalization_enabled' or 'orchestration.holdout_cookie_name'.
  // Key with '.' requires to find property value in a nested config object
  const keyArray = key.split(".");
  const finalPropertyValue = keyArray.reduce((propertyValue, element) => {
    if (!propertyValue) {
      return propertyValue;
    }
    if (element === "disabled") {
      log.debug(`property ${key} is disabled`);
      return "";
    }
    if (typeof propertyValue[element] === "undefined") {
      // Silence the log if the key is not found in the config
      // log.debug(`No value found for key - ${key}. Set to default value - ${defaultValue}`)
      return defaultValue;
    }
    return propertyValue[element];
  }, rootConfig);

  return finalPropertyValue;
};

module.exports = { getConfigPropertyValue };
